module.exports = __webpack_public_path__ + "00f9c4f5b934fcfa29fab40b7b417d6b.svg";